// Web-only strings for the 2026-10-18 compose parity pass (scheduled messages, undelivered strip,
// durable attachments, Markdown preview, Nuevo chat de WhatsApp, group → private channel). BOTH
// languages. Everything the Apple tables already say (schedule.*, channel.undelivered*,
// whatsappChat.*, groupConversion.*) comes from the generated catalogue.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.scheduled.actionFailed': 'No se pudo completar. El mensaje programado sigue igual.',
    'web.scheduled.scheduled': 'Mensaje programado: %@',
    'web.scheduled.menu': 'Programar mensaje…',
    'web.scheduled.uploadFailed': 'Un archivo no se pudo subir. No se programó nada.',
    'web.compose.preview': 'Vista previa',
    'web.compose.previewHide': 'Volver a escribir',
    'web.compose.previewEmpty': 'Nada que previsualizar.',
    'web.attachments.restored': 'Se recuperaron los archivos que estabas adjuntando.',
    'web.groupConversion.done': 'El grupo ahora es un canal privado.',
  },
  en: {
    'web.scheduled.actionFailed': "Couldn't do that. The scheduled message is unchanged.",
    'web.scheduled.scheduled': 'Message scheduled: %@',
    'web.scheduled.menu': 'Schedule message…',
    'web.scheduled.uploadFailed': "A file couldn't be uploaded. Nothing was scheduled.",
    'web.compose.preview': 'Preview',
    'web.compose.previewHide': 'Back to writing',
    'web.compose.previewEmpty': 'Nothing to preview.',
    'web.attachments.restored': 'The files you were attaching were recovered.',
    'web.groupConversion.done': 'The group is now a private channel.',
  },
};
